import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";

interface CustomerSelectorProps {
  selectedCustomer: string;
  user: any;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function CustomerSelectorV2({
  selectedCustomer,
  user,
  onChange,
}: CustomerSelectorProps) {
  const [customers, setCustomers] = useState<{ label: string; value: string }[]>(
    []
  );
  const [selected, setSelected] = useState<{ label: string; value: string } | null>(null);

  const fetchCustomers = async () => {
    const customerList = await axios.get(`${process.env.REACT_APP_API_URL}/konfidency/admin/customers/keys`);
    const formatted = customerList.data.map((item: any) => ({
      label: `${item.key} ${item.active ? '' : '(inativo) ❌'}`,
      value: item.key,
    }));
    setCustomers(formatted);
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  useEffect(() => {
    const found = customers.find((opt) => opt.value === selectedCustomer);
    setSelected(found ?? null);
  }, [customers, selectedCustomer]);

  return (
    <div className="d-flex align-items-center" style={{ position: "relative" }}>
      <div className="w-300px">
        <Select
          options={customers}
          value={selected}
          onChange={(option:any) => {
            const fakeEvent = {
              target: { value: option?.value ?? "" },
            } as React.ChangeEvent<HTMLSelectElement>;
            onChange(fakeEvent);
          }}
          placeholder="Selecione um cliente"
          isSearchable
          className="form-select-dropdown w-300px"
        />
      </div>
    </div>
  );
}